<!--
 * @Author: kongxiangyu
 * @Date: 2022-11-22 14:11:07
 * @LastEditTime: 2023-02-11 09:05:51
 * @email: kongxiangyu@cd.baidu.com
 * @Description: 今日爆款
-->
<template>
    <div
        v-if="(list.list.length > 0) || list.done"
        id="sale"
        class="todaySale"
    >
        <div class="top">
        </div>

        <div class="list">
            <div v-if="list.list.length > 0 || list.done">
                <div class="couponXc">
                    <div class="priceBox">
                        <div>
                            <span class="unit">¥</span>
                            <span class="price">{{ sale_coupon.coupon_list[0].discount_amount }}</span>
                        </div>
                    </div>
                    <span class="limit">{{ sale_coupon.coupon_list[0].use_coupon_str }}</span>
                    <span class="tips">{{ sale_coupon.coupon_list[0].use_rule_str }}</span>
                    <div
                        class="buy"
                        :style="{backgroundImage: 'url(' +
                            circleMap[sale_coupon.coupon_list[0].code_status].bg +
                            ')'}"
                        @click="handlePay(sale_coupon,'xc')"
                    >
                        {{ getZcBtnText }}
                    </div>
                </div>
            </div>
            <div v-if="list.list.length !== 0" class="listWrap">
                <div
                    v-for="(item,index) in (list.direction ? list.list.slice(0,9) : list.list)"
                    :key="index + 'list'"
                    class="good"
                    @click="jump(item.detail_url,item.product_id)"
                >
                    <img
                        class="head-pic"
                        :src="item.pic_url"
                        alt=""
                        @error="onImgError"
                    >
                    <span class="tip">{{ item.discount_rate }}折</span>
                    <span class="location">
                        <img
                            class="location-img"
                            src="../../../assets/location.png"
                            alt=""
                        >
                        {{ item.distance }}
                    </span>
                    <p class="title">{{ item.product_name }}</p>
                    <p class="brand">{{ item.shop_name }}</p>
                    <div class="box">
                        <div class="content">
                            <span class="priceLeft">¥{{ item.sale_price / 100 }}</span>
                            <span class="discount">
                                立减{{ item.coupon_amount / 100 }}元
                            </span>
                            <span class="priceRight">¥{{ item.sale_price / 100 }}</span>
                        </div>
                    </div>
                    <p class="time">仅限活动当天</p>
                    <div class="btn">
                        <span class="btn-left">券后价</span>
                        <span class="btn-right">
                            <span class="unit">¥</span>{{ item.baidu_discount_price / 100 }}
                        </span>
                    </div>
                </div>
                <div
                    v-if="list.showDirection"
                    class="more"
                    @click="handleMore(list.name)"
                >
                    {{ list.direction ? '查看更多' : '收起' }}
                    <i :class="list.direction ? 'down' : 'up'"></i>
                </div>
            </div>
            <div v-else class="noData">
                暂无数据...
            </div>
        </div>
    </div>
</template>

<script>
import Const from '../../../constant/Constant.js';
import EventBus from '../../../constant/EventBus.js';
import {getParamsFromUrl} from '@baidu/map-fe-utils';
import Server from '../../../service.js';
import StatisticConst from '../../../constant/StatisticConst.js';
export default {
    props: {
        dataSource: {
            type: Object,
            detault: () => {
                return null;
            }
        }
    },
    data() {
        return {
            zcData: null,
            circleMap: Const.circleMap,
            list: {
                src: require('../../../assets/tab-zc.png'),
                list: [],
                direction: true,
                showDirection: true,
                done: false
            }
        };
    },
    computed: {
        sale_coupon() {
            return this.dataSource.card_data.sale_coupon;
        },
        getZcBtnText() {
            return this.circleMap[this.dataSource.card_data.sale_coupon.coupon_list[0].code_status].text;
        }
    },
    created() {
        this.getGoodList();
    },
    watch: {
        dataSource: {
            handler(val) {
                if (val.card_data) {
                    val.card_data.sale_coupon.coupon_list.forEach(item => {
                        if (item.stock_left === 0) {
                            item.code_status = 101;
                        }
                    });
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        onImgError(e) {
            e.target.src = require('../../../assets/default.png');
        },
        /**
         * 点击购买券
         */
        handlePay(sale_coupon, type) {
            StatisticConst.tianmiyushouClick();
            if (sale_coupon.coupon_list[0].code_status === -1) {
                const data = {
                    room_id: this.dataSource.room_id,
                    bdmap_coupon_ids: sale_coupon.coupon_list[0].bdmap_coupon_id,
                    good_id: sale_coupon.sale.good_id
                };
                this.$emit('pay', data);
            }
            else if (sale_coupon.coupon_list[0].code_status === 0) {
                // 铆点
                document.querySelector('#goodList').scrollIntoView({
                    behavior: 'smooth'
                });
                EventBus.$emit('switchTab', type);
            }
            else {
                return;
            }

        },
        getGoodList() {
            const [loc_x, loc_y] = getParamsFromUrl().loc.replace('(', '').replace(')', '').split(',');
            const params = {
                activity_id: this.dataSource.card_data.product_list[0].product_activity_id,
                component_id: this.dataSource.card_data.product_list[0].product_option_id,
                loc_x: loc_x || '12947476.969463786',
                loc_y: loc_y || '4846478.119990898',
                is_local: 1,
                city_id: getParamsFromUrl().c || 131,
                biz: 'cater',
                room_id: this.dataSource.room_id,
                page_size: 30

            };
            // eslint-disable-next-line @babel/new-cap
            Server('GetGoodList', params)
                .then(res => {
                    if (res.errno === 0) {
                        const length = res.data.product_list.length;
                        const num = length % 3;
                        res.data.product_list.length = length - num;
                        this.list.done = true;
                        this.list.list = res.data.product_list || [];

                        if (res.data.product_list.length < 10) {
                            this.list.showDirection = false;
                        }
                    }
                    else {
                        // this.$toast(res.msg);
                    }
                })
                .catch(e => {
                    console.error(e.message);
                });
        },
        jump(url, id) {
            StatisticConst.goodsClick({
                id,
                module: 'tianmiyushou'
            });
            window.location.href = url;
        },
        /**
         * 点击查看更多
         */
        handleMore() {
            this.list.direction = !this.list.direction;
        }
    }
};
</script>

<style lang="scss" scoped>
    .top{
        width:calc(100% - 20px);
        margin-left:10px;
        background-image: url('../../../assets/jinribaokuan.png');
        background-size: 100% 100%;
        height:64px;
        position:relative;

    }
    .couponXc{
        background-size: 100% 100%;
        background-image: url('../../../assets/today-coupon-xc.png');
        height:92px;
        width:332px;
        margin:0 auto;
        position:relative;
        z-index: 1;
        font-family: PingFang SC;
        margin-bottom:8px;
        .priceBox{
            height:100%;
            width:100px;
            display:flex;
            justify-content: center;
            align-items: center;
            color:#FF4000;
            .unit{
                font-size: 12px;
                font-weight: 500;
            }
            .price{
                font-size: 40px;
                font-weight: 600;
            }
        }

        .limit{
            font-size: 15px;
            font-weight: 600;
            color: #FF4000;
            position:absolute;
            left:102px;
            top:27px;
            width:150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
        }
        .tips{
            font-size: 12px;
            font-weight: 500;
            color: #9E461C;
            position: absolute;
            left: 102px;
            top: 50px;
        }
        .buy{
            width: 86px;
            height: 43px;
            background-size: 100% 100%;
            position:absolute;
            right:15px;
            top:23px;
            font-size:14px;
            font-weight: bold;
            color:#FFF4AE;
            display: flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
        }
    }
    .list{
        background-image: url('../../../assets/middle.png');
        background-size: 100% 100%;
        width:calc(100% - 40px);
        margin-left:10px;
        padding:0 10px;
        position:relative;
        top:-1px;
        padding-bottom:10px;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        .listWrap{
                padding:0 5px;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                .good{
                    width:105px;
                    border-radius:8px;
                    margin-bottom:20px;
                    overflow: hidden;
                    position:relative;
                    .head-pic{
                        width:100%;
                        height:73px;
                        vertical-align: middle;
                    }
                    .tip{
                        position:absolute;
                        left:0;
                        top:0;
                        width:33px;
                        height:15px;
                        display: block;
                        line-height:15px;
                        text-align: center;
                        background-image: url('../../../assets/tip.png');
                        background-size: 100% 100%;
                        font-size: 10px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #FFECDA;
                    }
                    .location{
                        position:absolute;
                        left:5px;
                        top:57px;
                        display: flex;
                        min-width:45px;
                        height: 15px;
                        background: rgba(0,0,0,0.4);
                        border-radius: 6px;
                        justify-content: flex-start;
                        align-items: center;
                        font-size: 11px;
                        font-family: PingFang SC;
                        font-weight: 300;
                        padding: 0 5px;
                        color: #FFF5F5;

                        .location-img{
                            width:8px;
                            height:8px;
                            margin-right:3px;
                        }
                    }
                .title{
                    font-size: 13px;
                    font-family: PingFang SC;
                    font-weight: 600;
                    color: #060708;
                    margin:8px auto 7px;
                    text-align: left;
                    width:100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .brand{
                    font-size: 10px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #838C97;
                    text-align: left;
                    margin-bottom:8px;
                    width:100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .box{
                    width:100%;
                    height:24px;
                    background:url('../../../assets/tab-bg.png');
                    background-size: 100% 100%;
                    position:relative;
                    .content{
                        display:flex;
                        justify-content: space-between;
                        align-items: center;
                        padding:0 2px;
                        white-space: nowrap;
                        .priceLeft{
                            text-decoration: line-through;
                            font-size:7px;
                            color:#a0a8b1;
                            font-family: PingFang SC;
                            width: 30px;
                            text-align: left;
                        }
                        .priceRight{
                            text-decoration: line-through;
                            font-size:7px;
                            color:#a0a8b1;
                            font-family: PingFang SC;
                            width: 30px;
                            text-align: right;
                        }
                        .discount{
                            font-size: 9px;
                            font-family: PingFang SC;
                            font-weight: 500;
                            color: #FFFFFF;
                            text-shadow: 0px 1px 2px rgba(255,77,43,0.8);
                        }
                    }

                }
                .time{
                    font-size: 11px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #E91038;
                    margin:4px auto 5px;
                }
                .btn{

                    width:65px;
                    height: 29px;
                    background: url('../../../assets/tab-btn.png');
                    background-size: 100% 100%;
                    display:flex;
                    align-items: center;
                    justify-content: space-between;
                    padding:0 20px;
                    white-space: nowrap;
                    .btn-left{
                        font-size: 12px;
                        font-family: Lantinghei SC;
                        font-weight: 600;
                        color:#FFF0DB;
                        text-shadow: 0px 1px 2px #FF312E;
                    }
                    .btn-right{
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color:#FFF0DB;
                        text-shadow: 0px 1px 2px #FF312E;
                        .unit{
                            font-size:9px;
                        }
                    }
                }
                }
            }
        .item{
            width:80px;
            .box{
                width:100%;
                position:relative;
                height:55px;
                border-radius: 7px;
                overflow: hidden;

                .good-pic{
                    width:100%;
                    height:55px;
                }
                .rectangle{
                    width:100px;
                    height:15px;
                    position: absolute;
                    bottom:0;
                    left:0;
                }
                .bar{
                    width:100px;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    padding:0 5px 0 5px;
                    box-sizing: border-box;
                    white-space: nowrap;
                    overflow: hidden;
                    color:white;
                    height:15px;
                    position: absolute;
                    bottom:0;
                    left:0;
                    span{
                        display:inline-block;
                        height:15px;
                    }
                    .now{
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #FFF8EF;
                        font-size:12px;
                        .unit{
                            font-size: 7px;
                        }
                    }
                    .prev{
                        line-height: 23px;
                        font-size: 10px;
                        text-decoration: line-through;
                        .unit{
                            font-size: 8px;
                        }
                    }
                    .buy{
                        font-size: 11px;
                    }
                }
            }
            .good-title{
                font-size: 13px;
                font-weight: 600;
                color: #000000;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: left;
                // line-height:14px;
            }
            .merchant{
                font-size: 10px;
                line-height:11px;
                font-weight: 600;
                color: #5C6370;
                white-space: nowrap;
                text-align: left;
            }
        }
        .more{
            width:100%;
            font-size: 12px;
            text-align: center;
            font-family: PingFang SC;
            font-weight: 400;
            color: #666666;
            display: flex;
            justify-content: center;
            align-items: center;
            margin:0 0 20px 0;
            i {
                border: solid #666666;
                border-width: 0 1px 1px 0;
                display: inline-block;
                padding:4px;
                margin-left:5px;
            }
            .down {
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
                margin-bottom: 3px;
            }
            .up {
                transform: rotate(-135deg);
                -webkit-transform: rotate(-135deg);
                margin-top: 6px;
            }
        }
    }
</style>